import axios from "axios";

export default axios.create({
  baseURL: "https://centers.api.a1tutor.org/v1/",
});
